import {useState, useEffect} from 'react';

export default function AuthorizationTable({onChange, value, i18n}) {
    const rows = value.map(entry => {
        const match = entry.key.match(/^([A-Z]?)_([A-Z]?)_([A-Z]+)$/);
        if (match) {
            const [col1, col2, col3] = match.slice(1).map(value => !value ? '-' : value);
            return {col1, col2, col3, key: entry.key, action: entry.value};
        }
        return null;
    });

    const handleActionChange = (idx, key, newAction) => {
        onChange(key, newAction);
    };

    return (
        <div className={'threeds-config-container'}>
            <table>
                <thead>
                <tr>
                    <th>{i18n.enrollment_status}</th>
                    <th>{i18n.authentication_status}</th>
                    <th>{i18n.liability_shift}</th>
                    <th>{i18n.action}</th>
                </tr>
                </thead>
                <tbody>
                {rows.map((row, index) => (
                    <tr key={index}>
                        <td className="column-enrollment-status">
                            {row.col1 && <code>{row.col1}</code>}
                        </td>
                        <td className="column-authentication-status">
                            {row.col2 && <code>{row.col2}</code>}
                        </td>
                        <td className="column-liability-shift">
                            {row.col3 && <code>{row.col3}</code>}
                        </td>
                        <td className="column-action">
                            <select
                                value={row.action}
                                onChange={(e) => handleActionChange(index, row.key, e.target.value)}>
                                <option value="continue">{i18n.continue}</option>
                                <option value="reject">{i18n.reject}</option>
                            </select>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}